import CheckIcon from '@mui/icons-material/Check';
import CloseIcon from '@mui/icons-material/Close';
import ErrorIcon from '@mui/icons-material/Error';
import { Alert, Box, Card, CardContent, Typography } from '@mui/material';

const InfoRow = ({ label, value, valueColor = '#000' }) => {
  if (value === undefined || value === null) return null;

  return (
    <Typography sx={{ mb: 1.5, fontSize: '1.1rem', color: '#000' }}>
      {label}{' '}
      <Box component='span' sx={{ fontWeight: 'bold', color: valueColor }}>
        {value}
      </Box>
    </Typography>
  );
};

const getHomologatedColor = (homologatedValue, band28Value) => {
  const normalized = String(homologatedValue || '').toUpperCase();
  const normalizedBand28 = String(band28Value || '').toUpperCase();

  if (normalized === 'NO COMPATIBLE') {
    return '#dc2626';
  }

  if (normalizedBand28 === 'SI') {
    return '#16a34a';
  }

  return '#000';
};

const MenuImeiInfoWidget = ({ data, dataError }) => {
  const { deviceFeatures, imei } = data || {};
  const homologatedColor = getHomologatedColor(imei?.homologated, deviceFeatures?.band28);
  const isNoCompatible = String(imei?.homologated || '').toUpperCase() === 'NO COMPATIBLE';

  return (
    <Box
      sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', p: 3, width: '100%' }}
    >
      {dataError ? (
        // --- ESTADO DE ERROR ---
        <Box sx={{ width: '100%', maxWidth: 380, mb: 4 }}>
          <Typography variant='h6' color='error' sx={{ mb: 1, textAlign: 'center' }}>
            Error al consultar IMEI
          </Typography>
          <Alert severity='error' icon={<ErrorIcon />}>
            {dataError}
          </Alert>
          {imei?.imei && (
            <Typography sx={{ mt: 2, textAlign: 'center' }}>
              IMEI: <b>{imei.imei}</b>
            </Typography>
          )}
        </Box>
      ) : (
        // --- ESTADO DE ÉXITO ---
        <>
          <Box
            sx={{
              width: 56,
              height: 56,
              backgroundColor: isNoCompatible ? '#dc2626' : '#388e3c',
              borderRadius: '50%',
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              mb: 2,
            }}
          >
            {isNoCompatible ? (
              <CloseIcon sx={{ color: '#fff', fontSize: 36 }} />
            ) : (
              <CheckIcon sx={{ color: '#fff', fontSize: 36 }} />
            )}
          </Box>

          <Typography
            variant='h5'
            sx={{
              fontWeight: 'bold',
              mb: 3,
              color: homologatedColor,
              textAlign: 'center',
              fontSize: '1.3rem',
              lineHeight: 1.2,
              whiteSpace: 'nowrap',
            }}
          >
            {imei?.homologated}
          </Typography>

          <Card
            variant='outlined'
            sx={{
              width: '100%',
              maxWidth: 430,
              borderRadius: 4,
              borderColor: '#cfd8dc',
              mb: 4,
              boxShadow: 'none',
            }}
          >
            <CardContent sx={{ p: 3, '&:last-child': { pb: 3 } }}>
              <InfoRow label='IMEI:' value={imei?.imei} />
              <InfoRow label='Marca:' value={deviceFeatures?.brand} />
              <InfoRow label='Modelo:' value={deviceFeatures?.model} />
              <InfoRow
                label='Homologado:'
                value={imei?.homologated}
                valueColor={homologatedColor}
              />
              <InfoRow label='Bloqueado:' value={imei?.blocked} />
              <InfoRow label='Compatible con banda 28:' value={deviceFeatures?.band28} />
              <InfoRow label='Soporta VoLTE:' value={deviceFeatures?.volteCapable} />
              <InfoRow label='Soporta eSIM:' value={imei?.soportaESIM} />
            </CardContent>
          </Card>
        </>
      )}
    </Box>
  );
};

export default MenuImeiInfoWidget;
